import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import type { PostSummary } from "@/lib/site";

let cache: PostSummary[] | null = null;

export function usePosts() {
  const [posts, setPosts] = useState<PostSummary[] | null>(cache);
  useEffect(() => {
    if (!cache) {
      api.get("/public/posts").then((r) => { cache = r.data; setPosts(r.data); }).catch(() => setPosts([]));
    }
  }, []);
  return posts;
}
